import { useState } from "react";
import Popup from "../../../hoc/Popup/Popup";
import { IRehabSummaryItem } from "../../../types/api";
import "./EditRehabSlotPopup.scss";
import { formatDateToSwedish } from "../../../shared/utility";
import greenCheck from "../../../assets/images/green-check.svg";

import { toast } from "react-toastify";
import {
  createRehabSlotComment,
  changeRehabSlotBookability,
} from "../../../api/rehab/rehab";
interface IEditRehabSlotPopupProps {
  onClose: () => void;
  showPopup: boolean;
  onConfirm: () => void;
  rehabSummaryItem?: IRehabSummaryItem;
  date: Date;
}

function EditRehabSlotPopup(props: IEditRehabSlotPopupProps) {
  const { rehabSummaryItem, date, showPopup, onClose, onConfirm } = props;

  const [editedRehabItemToCompare, setEditedRehabItemToCompare] =
    useState<IRehabSummaryItem | null>(null);
  const { weekday, dateAndMonth } = formatDateToSwedish(date);
  const [editCommentToggle, setEditCommentToggle] = useState(false);
  const [hasBooking, setHasBooking] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [comment, setComment] = useState("");
  const handleClose = () => {
    setEditCommentToggle(false);
    setComment("");
    setEditedRehabItemToCompare(null);
    onClose();
  };

  const getEndTime = (startTime: string) => {
    const hours = parseInt(startTime.slice(0, 2));
    const minutes = parseInt(startTime.slice(3, 5));

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    date.setMinutes(date.getMinutes() + 15);

    const newHours = date.getHours().toString().padStart(2, "0");
    const newMinutes = date.getMinutes().toString().padStart(2, "0");

    return `${newHours}:${newMinutes}`;
  };
  const rehabItemToLoop = editedRehabItemToCompare || rehabSummaryItem;

  const handleCommentSlot = async () => {
    if (!rehabSummaryItem) return;
    const datetime =
      date.toISOString().slice(0, 10) + "T" + rehabSummaryItem?.start_time;

    try {
      const response = await createRehabSlotComment(datetime, comment);
      if (response && "message" in response === false) {
        setEditedRehabItemToCompare(response);
        setEditCommentToggle(false);
        toast.success("Kommentar sparad");
        onConfirm();
      }
    } catch (error: any) {
      toast.error(error);
    }
  };

  const handleToggleBookable = async () => {
    if (!rehabItemToLoop) return;
    const datetime =
      date.toISOString().slice(0, 10) + "T" + rehabSummaryItem?.start_time;
    try {
      const response = await changeRehabSlotBookability(
        datetime,
        rehabItemToLoop.bookable || rehabItemToLoop.bookable === null
          ? false
          : true
      );
      if (response && "message" in response === false) {
        setEditedRehabItemToCompare(response);
        onConfirm();
        toast.success(
          `Tiden är nu ${
            rehabItemToLoop.bookable ? "inte bokningsbar" : "bokningsbar"
          }`
        );
      }
    } catch (error: any) {
      toast.error(error);
    }
  };

  return (
    <Popup
      showPopup={showPopup}
      onClose={handleClose}
      leftTopElement={
        <span className="text-m">
          Redigera denna slots kommentar och tillgänglighet
        </span>
      }
    >
      <div className="general-popup-wrapper">
        <form
          className="general-popup-form"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="general-popup-form-top"></div>
          <div className="general-popup-form-group mb-20">
            <div className="general-popup-form-field">
              <div className="general-popup-flex-between">
                <span className="text-m primary-text">Datum</span>
                <div className="text-m primary-text text-svg-wrapper">
                  <span>
                    {weekday}, {dateAndMonth}
                  </span>
                  <img src={greenCheck} alt="green check"></img>
                </div>
              </div>
              <div className="general-popup-flex-between">
                <span className="text-m primary-text">Vald tid</span>
                <div className="text-m primary-text text-svg-wrapper">
                  <span>
                    {rehabSummaryItem
                      ? rehabSummaryItem.start_time.slice(0, 5) +
                        " - " +
                        getEndTime(rehabSummaryItem.start_time).slice(0, 5)
                      : ""}
                  </span>
                  <img src={greenCheck} alt="green check"></img>
                </div>
              </div>
            </div>
          </div>
          <div className="general-popup-form-group mb-20">
            <div className="general-popup-form-field">
              <span className="text-m">Kommentar</span>
              <span className="text-m">{rehabItemToLoop?.comment || ""}</span>

              {!editCommentToggle && (
                <div className="general-popup-flex-right text-m">
                  <button
                    type="button"
                    onClick={() => setEditCommentToggle(true)}
                  >
                    {rehabItemToLoop?.comment !== "" ? (
                      <span> Uppdatera kommentar</span>
                    ) : (
                      <span>Lägg till kommentar</span>
                    )}
                  </button>
                </div>
              )}
              {editCommentToggle && (
                <>
                  <input
                    className="text-m"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  ></input>
                  <div className="general-popup-flex-right text-m">
                    <button type="button" onClick={() => handleCommentSlot()}>
                      Spara kommentar
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="general-popup-form-group mb-20">
            <div className="general-popup-form-field">
              <div className="general-popup-flex-between">
                <span className="text-m primary-text">
                  {rehabItemToLoop?.bookable
                    ? "Tillgänglig för bokning"
                    : "Otillgänglig för bokning"}
                </span>
                <button
                  type="button"
                  onClick={() => handleToggleBookable()}
                  className="text-m"
                >
                  {rehabItemToLoop?.bookable === true ||
                  rehabItemToLoop?.bookable === null
                    ? "Gör otillgänglig"
                    : "Gör tillgänglig"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Popup>
  );
}

export default EditRehabSlotPopup;
